import { call, put, takeLatest } from "redux-saga/effects";
import { duTruHocBongApi } from "../../../api/bao-cao/duTruHocBongApi";
import { Download, fileNameWithTime } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import {
  IDuTruHocBongRequest,
  ITyLeHocBongSaveRequest,
} from "../../../model/request/bao-cao/IDuTruHocBongRequest";
import {
  IDuTruHocBongKetQua,
  ITyLeHocBong,
} from "../../../model/respone/bao-cao/IDuTruHocBong";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDuTruHocBongActionIds,
  IDuTruHocBongActionTypes,
} from "../../action-types/bao-cao/IDuTruHocBongActions";
import { rootActions } from "../../actions/rootActions";

export function* duTruHocBongSaga(): any {
  yield takeLatest(eDuTruHocBongActionIds.LOAD_START, loadWorker);
  yield takeLatest(eDuTruHocBongActionIds.LOAD_TY_LE_START, loadTyLeWorker);
  yield takeLatest(eDuTruHocBongActionIds.SAVE_TY_LE_START, saveTyLeWorker);
  yield takeLatest(eDuTruHocBongActionIds.EXPORT_EXCEL_START, exportWorker);
  yield takeLatest(eDuTruHocBongActionIds.XEM_TRUOC_START, xemTruocWorker);
}

function* xemTruocWorker(action: IDuTruHocBongActionTypes): any {
  yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(true));
  try {
    const res: IBaseRespone = yield call(
      duTruHocBongApi.XemTruoc,
      action.payload as IDuTruHocBongRequest,
    );
    if (res.is_success) {
      yield put(
        rootActions.baoCao.duTruHocBong.XEM_TRUOC_SUCCESS(res.data as string),
      );
    } else {
      yield put(
        rootActions.baoCao.duTruHocBong.XEM_TRUOC_ERROR(res.message ?? "Có lỗi"),
      );
      NotifyHelper.Error(res.message ?? "Có lỗi");
    }
  } finally {
    yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(false));
  }
}

function* loadWorker(action: IDuTruHocBongActionTypes): any {
  const res: IBaseRespone = yield call(
    duTruHocBongApi.Select,
    action.payload as IDuTruHocBongRequest,
  );
  if (res.is_success) {
    yield put(
      rootActions.baoCao.duTruHocBong.LOAD_SUCCESS(
        res.data as IDuTruHocBongKetQua,
      ),
    );
  } else {
    yield put(
      rootActions.baoCao.duTruHocBong.LOAD_ERROR(res.message ?? "Có lỗi"),
    );
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* loadTyLeWorker(action: IDuTruHocBongActionTypes): any {
  const { hoc_ky, nam_hoc } = action.payload as {
    hoc_ky: number;
    nam_hoc: string;
  };
  const res: IBaseRespone = yield call(
    duTruHocBongApi.SelectTyLe,
    hoc_ky,
    nam_hoc,
  );
  // Chưa khai tỷ lệ cho học kỳ này thì máy chủ trả rỗng — không phải lỗi.
  if (res.is_success)
    yield put(
      rootActions.baoCao.duTruHocBong.LOAD_TY_LE_SUCCESS(
        res.data as ITyLeHocBong,
      ),
    );
}

function* saveTyLeWorker(action: IDuTruHocBongActionTypes): any {
  const res: IBaseRespone = yield call(
    duTruHocBongApi.SaveTyLe,
    action.payload as ITyLeHocBongSaveRequest,
  );
  if (res.is_success) {
    yield put(
      rootActions.baoCao.duTruHocBong.SAVE_TY_LE_SUCCESS(
        res.data as ITyLeHocBong,
      ),
    );
    NotifyHelper.Success("Đã lưu tỷ lệ quỹ học bổng của học kỳ");
  } else {
    yield put(
      rootActions.baoCao.duTruHocBong.SAVE_TY_LE_ERROR(res.message ?? "Có lỗi"),
    );
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* exportWorker(action: IDuTruHocBongActionTypes): any {
  const request = action.payload as IDuTruHocBongRequest;
  // Lớp phủ "đang xử lý": biểu gom cả trường chạy lâu, không có nó người dùng tưởng treo.
  yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(true));
  try {
    const res: IBaseRespone = yield call(duTruHocBongApi.ExportExcel, request);
    if (res.is_success) {
      Download.Excel(
        res.data as string,
        `${fileNameWithTime(
          `Du tru hoc bong HK${request.hoc_ky} ${request.nam_hoc}`,
          "Dự trù học bổng",
        )}.xlsx`,
      );
      yield put(rootActions.baoCao.duTruHocBong.EXPORT_EXCEL_SUCCESS(""));
    } else {
      yield put(
        rootActions.baoCao.duTruHocBong.EXPORT_EXCEL_ERROR(
          res.message ?? "Có lỗi",
        ),
      );
      NotifyHelper.Error(res.message ?? "Có lỗi");
    }
  } finally {
    // finally: hỏng giữa chừng (mất mạng, hết phiên) cũng phải gỡ lớp phủ.
    yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(false));
  }
}
